import { render } from "./SearchStartTabContent.pug?vue&type=template&id=e0a3a6bc&lang=pug"
import script from "./SearchStartTabContent.js?vue&type=script&lang=js"
export * from "./SearchStartTabContent.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__